import { DialogBlock } from '../../DialogBlocks/DialogBlock';
import { BaseDialogNode } from '../BaseDialogNode';

export abstract class ActionDialogNode extends BaseDialogNode {
  constructor(dialogBlock: DialogBlock) {
    super(dialogBlock);
  }
}
